import React, { useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";

const SearchableDropdown = ({
    label,
    id,
    selectedValue,
    onSelectValue,
    options,          // full list [{ value, label }]
    filteredOptions,  // filtered list [{ value, label }]
    searchTerm,
    setSearchTerm,
    placeholder,
}) => {
    const [show, setShow] = useState(false);

    const handleToggle = (nextShow) => {
        setShow(nextShow);
        if (nextShow) {
            // optional: clear search whenever you open it
            // setSearchTerm("");
        }
    };

    const handleSelect = (eventKey) => {
        onSelectValue(eventKey);
        setShow(false); // close after picking an item
    };

    const selectedOption = options.find(
        (o) => String(o.value) === String(selectedValue)
    );

    const hasNoResults = filteredOptions.length === 0 && !selectedValue;

    const selectedLabel =
        selectedOption?.label ||
        (hasNoResults ? "No data" : placeholder || `Select ${label}`);

    return (
        <div className={`form-group ${label?.toLowerCase()}-input`}>
            <label htmlFor={id} className="mr-2">
                {label}:
            </label>

            <Dropdown
                show={show}
                onToggle={handleToggle}
                onSelect={handleSelect}
            >
                <Dropdown.Toggle
                    variant="light"
                    id={id}
                    className="mr-2"
                >
                    <div className="fixed-width">
                        {selectedLabel}
                    </div>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {/* prevent clicks in this area from closing/toggling */}
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            className="search-input-events"
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>

                    {filteredOptions.map((opt) => (
                        <Dropdown.Item key={opt.value} eventKey={opt.value}>
                            {opt.label}
                        </Dropdown.Item>
                    ))}

                    {filteredOptions.length === 0 && (
                        <div className="px-3 py-2 text-muted">No results found</div>
                    )}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default SearchableDropdown;
